<template>
  <div id="app">
    <mf-fetching></mf-fetching>
    <mf-nav-bar v-show="shouldShowNavigation"></mf-nav-bar>

    <div class="container">
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
import MfNavBar from './components/root/navbar'
import MfFetching from './components/fetching'

export default {
  name: 'app',
  components: {
    MfNavBar, MfFetching
  },
  computed: {
    shouldShowNavigation: function () {
      return this.$route.name !== 'auth.singin'
    }
  }
}
</script>

<style lang="sass" src="@/assets/sass/app.scss"></style>



// WEBPACK FOOTER //
// src/Root.vue